import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="flex flex-col space-y-8 pt-10 md:pt-16 pb-10 items-center">
      <div>
        <div className="text-6xl text-primary font-semibold">Oops!</div>
        <div className="uppercase mt-5 font-semibold">404 - Page Not Found</div>
      </div>

      <div className="text-center">
        <div className="max-w-sm xl:max-w-md mx-auto">
          Halaman yang kamu cari mungkin sudah dihapus atau tidak bisa diakses
          untuk sementara waktu.
        </div>
        <div className="mt-5">
          <Link to="/">
            <div className="cursor-pointer underline text-primary">
              Kembali ke Dashboard
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
